import { useMutation, useQuery } from 'react-query';
import useApi from '../../../hooks/use-api';
import getUserFullName from '../../../utilities/get-user-full-name';
import useCacheKeys from '../../../hooks/use-cache-keys';
import useCache from '../../../hooks/use-cache';
import useCourseEnroll from './use-course-enroll';
import gradeNumber from '../../../utilities/grade-number';

export const useEnrollees = ({
    courseId
}) => {
    const { api, url, endpoints } = useApi();
    const cacheKeys = useCacheKeys()
    const cacheKey = [cacheKeys.COURSES, courseId, 'enrollees'];
    const { clearCache } = useCache({ key: cacheKey })
    const query = useQuery(
        cacheKey,
        () => api.get(url(endpoints.courseEnrollees, { courseId }))
    );

    const courseEnroll = useCourseEnroll({
        courseId,
        onSuccess: clearCache
    })

    const students = (query.data || [])
        .map(student => ({
            name: getUserFullName(student),
            gradeNumber: gradeNumber(student.gradYear),
            ...student
        }));

    const isLoading = query.isLoading || courseEnroll.isLoading;

    const enroll = courseEnroll.enroll;

    return {
        isLoading,
        students,
        clear: clearCache,
        enroll
    };
};
